import React, {
  Fragment,
  useState,
  useContext,
  useEffect,
  useCallback,
} from "react";
import { GlobalContext } from "../../context/GlobalState";
import { CardNoData } from "../Cards/noData";
import { Shipment } from "../Shipment";
import imagenLogin from "../resources/Imagen_Login_basic.png";
import { Col } from "reactstrap";
import { PublicAccessRepository } from "../../repositories";
// const BackgroundHead = {
//   height: "100%",
//   backgroundImage: `url(${MAPIMG})`,
//   backgroundSize: "cover",
//   backgroundPosition: "center",
//   width: "calc(100vw + 48px)",
//   margin: -24,
//   padding: 57,
// };

const BackgroundHead = {
  backgroundImage: "url(" + imagenLogin + ")",
  backgroundSize: "cover",
};

export const ListResult = (route) => {
  const { ResultsList, SearchParam, resultList } = useContext(GlobalContext);
  const [flag, setFlag] = useState(true);

  const trackId = route.match.params.id;

  const fetchData = useCallback(async () => {
    // let url = `${Services.PublicAccess.path}search?filter=${trackId}&log=false`
    // let tracking = await Axios.get(url);
    let tracking;

    if (resultList && resultList[0]?.selectUser) {
      let body = {
        filter: trackId,
        branch: resultList[0].Branch,
      };
      tracking = await PublicAccessRepository.getSearchWithBranch(
        body,
        "false"
      );
    } else {
      tracking = await PublicAccessRepository.getSearch(trackId, "false");
    }

    SearchParam(trackId);
    if (tracking?.data?.length === 1) {
      ResultsList(tracking.data);
      setFlag(true);
    } else {
      setFlag(false);
    }

    // if (tracking.data.data.length > 2) {
    //   valid = false;
    //   ResultsList(tracking.data.data);
    // } else {
    //   valid = true;
    // }

    // Results(valid);
  }, [ResultsList, SearchParam, trackId]);

  useEffect(() => {
    fetchData();
  }, [trackId]);

  return (
    <Fragment>
      {flag ? (
        <Shipment />
      ) : (
        <div style={BackgroundHead}>
          <div className="container-login">
            <Col xs={12} md={8} lg={9} className="ml-auto mr-auto">
              <CardNoData />
            </Col>
          </div>
        </div>
      )}
    </Fragment>
    // <Fragment>
    //   {resultList.length ? (
    //     resultList.length === 1 ? (
    //       <Shipment />
    //     ) : (
    //       <ShowResults />
    //     )
    //   ) : (
    //     <div className="limiter" style={BackgroundHead}>
    //       <div className="container-login100">
    //         <div
    //           className="wrap-login100"
    //           style={{
    //             width: "80em",
    //             marginTop: "1em",
    //             marginLeft: "5em",
    //             background: "transparent",
    //           }}
    //         >
    //           <div className="col-12">{results ? <CardNoData /> : ""}</div>
    //         </div>
    //       </div>
    //     </div>
    //   )}
    // </Fragment>
  );
};
